import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EditTruck, getCount, getMatchingLoads, GetTruckPostByID } from "../../../Utils/AllPagesQuriesAndMutations";
import { Loading, LoadTable } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import { Confirm } from "../../Components/Confirmation/Confirm";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import { MatchingModal } from "../LoadEntry/MatchingTrucks";

import useProcessData from "../../../CommonFunction/ProcessData";
import { EDIT_LOAD } from "../LoadEntry/LoadEntry";
import "./Truck.scss";





const queryfunction = (fields: []) => {
  const query = gql`
    query GetAllTruckPost($Is_Live:Boolean) {
      GetAllTruckPost(Is_Live:$Is_Live) {
        ${fields?.join(" ")}
        Matching_Load_Count
      }
    }
  `;

  return query;
};
//

const TruckPost = () => {
  const title = "Truck_Post";
  const [showMatchingLoads, setMatchingLoads] = useState(false);
  const [Tab, SetTab] = useState("Live");
  const [toggle, setToggle] = useState(false);
  const [Id, setId] = useState("");
  const [formdata, setformdata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let Refetch = useSelector((store: any) => store?.FormFieldData.refresh);
  let statusTab = [{ name: "Live" }, { name: "Expired" }, { name: "All_Trucks" }];
  const dispatch = useDispatch();
  const [Key, setKey] = useState("Truck_Post_Live");
  const getCategoryFromTab = (tab) => {
    switch (tab) {
      case "Expired":
        return { Is_Live: false };
      case "Live":
        return { Is_Live: true };
      case "All_Trucks":
        return {};
      default:
        return {};
    }
  };
  const [EditTruckPost, { loading: EditTruckLoading }] = useMutation(EditTruck, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [RefetchCount] = useMutation(getCount, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [fetchTrucks, { loading: loaderquery, error, data }] = useLazyQuery(
    gql`
      query GetAllTruckPost($Is_Live: Boolean) {
        GetAllTruckPost(Is_Live: $Is_Live) {
          _id
        }
      }
    `,
    {
      variables: getCategoryFromTab(Tab),
      fetchPolicy: "network-only",
      context: {
        headers: { "X-GraphQL-Server": "secondary" },
      },
      onCompleted: () => {
        setIsLoading(false);
      },
    }
  );

  useEffect(() => {
    const Tabdata = {
      key: title,
      data: Tab,
    };
    setKey(`Truck_Post_${Tab}`);
    dispatch({ type: "UNIQUE_TAB_SELECT", payload: Tabdata });
    dispatch({ type: "Refetch", payload: true }); // Trigger the lazy query when Refetch 
  }, [Tab]);


  useEffect(() => {
    const selectedCategory = getCategoryFromTab(Tab);
    console.log(selectedCategory)
    if (Refetch) {
      fetchTrucks({ variables: selectedCategory });
      dispatch({ type: "Refetch", payload: false });
    }
  }, [Refetch, Tab]); // Add Tab to the dependencies

  const { loading } = useFetchTableData(queryfunction, fetchTrucks, setIsLoading, "Truck_Post");

  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  const RefreshFunction = () => {
    RefetchCount().then((res) => {
      SuccessToast("Matching Loads count has Updated..!");
    });
  };
  function Submit(Id) {
    EditTruckPost({
      variables: {
        id: Id,
        userInput: {
          Is_Live: false,
          Is_Archive: true,
        },
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast("Truck Closed");
        setToggle(false);
      })
      .catch((err) => ErrorToast(err.message));
  }
  // Map the request data
  const config = useMemo(
    () => ({
      dataKey: "GetAllTruckPost",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["is_Audit", "__typename", "Is_Live", "Truck_Repost_Time"],
      AddCol: [
        {
          colName: "Matching_Load",
          value: (obj) => {
            return obj?.Matching_Load_Count ? (
              <a
                href="#"
                style={{ color: "blue", textDecoration: "none" }}
                onClick={() => {
                  setMatchingLoads(true);
                  setId(obj._id);
                }}
              >
                Matching Load
              </a>
            ) : (
              "No Matching Loads"
            );
          },
        },
        {
          colName: "Close",
          value: (obj) => {
            return (
              <a
                href="#"
                style={{ color: "blue", textDecoration: "none" }}
                onClick={() => {
                  setToggle(true);
                  setId(obj._id);
                }}
              >
                Close
              </a>
            );
          },
        },
      ],
      calculateAge: "Truck_Repost_Time",
    }),
    []
  );
  {
  }
  const { loading: processDataLoading } = useProcessData(data, setformdata, config, error);

  return (
    <>
      <div className="LoadContainer">
        <div className="HeaderDiv">
          <div>
            <p className="pageTitle">Trucks</p>
            <div className="hr1ForPageTitle"></div>
          </div>
          <SearchBoxesDiv />
        </div>
        <Tabs tabs={statusTab} SetTabPage={SetTab} />
        <div className="ActionTray">
          <HeaderDiv title={""} func={RefreshFunction} TableKey={title} MoreActions={{Is_Count:true}} />
        </div>
        {isLoading ? (
          <Loading />
        ) : !formdata?.length ? (
          <p className="DataNotAvailable">Data not Available</p>
        ) : (
          <>
            {(loaderquery || loading) && <div className="loader-line-div" />}
            <LoadTable title={`Truck_Post`} data={formdata} loading={loading} error={error} Tab={Key} />
          </>
        )}
      </div>
      {toggle && (
        <Confirm
          settoggle={setToggle}
          loadingState={EditTruckLoading}
          toggle={toggle}
          submitType="Yes"
          submit={() => Submit(Id)}
          message={"Are You Sure You want to Close This Truck"}
        />
      )}
      {showMatchingLoads && (
        <MatchingModal
          TypeofPortal="Matching Loads"
          show={showMatchingLoads}
          Id={Id}
          setShowModal={() => setMatchingLoads(!showMatchingLoads)}
          query={getMatchingLoads}
          dataKey={"getMatchingLoadsForTheTruck"}
          dataById={GetTruckPostByID}
          Edit={EDIT_LOAD}
        />
      )}
    </>
  );
};

export default TruckPost;
